import PropTypes from 'prop-types'
import { Button } from '@material-ui/core'
import { TableRow, TableCell } from 'components/Table'
import helpers from 'helpers'
import { MenuButton } from 'components'
import { useHistory } from 'react-router-dom'
import { reverse } from 'named-urls'
import { routes } from 'Routes'

const OrdersTableRow = ({ order }) => {
  const history = useHistory()

  return (
    <>
      <TableRow key={order?.token}>
        <TableCell>{order?.sellerName}</TableCell>
        <TableCell>{order?.buyer?.name}</TableCell>
        <TableCell>
          {helpers.formatters.floatToMoney(order?.amount, true)}
        </TableCell>
        <TableCell>{helpers.orders.statusLabel(order?.status)}</TableCell>
        <TableCell>{helpers.formatters.date(order?.createdAt)}</TableCell>
        <TableCell align="right">
          <MenuButton>
            <Button
              fullWidth
              size="small"
              onClick={() =>
                history.push(
                  reverse(routes.orders.show, {
                    orderId: order?.token,
                  }),
                )
              }
            >
              Detalhes
            </Button>
          </MenuButton>
        </TableCell>
      </TableRow>
    </>
  )
}

OrdersTableRow.defaultProps = {
  order: PropTypes.object,
}

export default OrdersTableRow
